import { useContext, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import PageContext from './PageContext';
import { HttpContext } from '../../api-services/HttpService';
import ApiRequestButton from './ApiRequestButton';
import DynamicPageInput from './DynamicPageInputCopy.jsx';
import validateInputArray from '../functions/validateInputArray';
import dynamicTransformation from '../functions/dynamicTransformation';
import dynamicValidation from '../functions/dynamicValidation';
import CCOffcanvas from './CCOffcanvas.tsx';
import ButtonComponent from './ButtonComponent.jsx';
import isNullOrUndefined from '../functions/isNullOrUndefined.js'; 
import { isAchFieldVisible, buildAchDynamicArgs, showAchInfoForMethod } from '../functions/payoutAchFields';

const AddPayoutInfoModal = () =>{
    const {
        addPayoutInfoModal, 
        setAddPayoutInfoModal, 
        getCompanyDetailsData,   
        snackbarAlert,
        masterCompanyData,
        payoutInfoConfig, 
        payoutInfoLists        
    } = useContext(PageContext);
    // initialize http context 
    const {
        POST, 
    } = useContext(HttpContext);
    // get global state
    const company = useSelector((state) => state.company);
    // initialize state
    const [values, setValues] = useState({}); 
    const [config, setConfig] = useState([]); 
    const [error, setError] = useState([{}]);
    // initialize state for master setup
    const [masterSetupBool, setMasterSetupBool] = useState(false);
    // derived: whether ach info fields show for the chosen payout method
    const showAchInfo = showAchInfoForMethod(values['payoutmethodid'], payoutInfoLists['payoutmethodid']);

    // event handler for values change 
    const onInputChange = () => {
        let temp = values; 
        // update companyid if master company payout is toggled 
        if (values['mastersetupbool'] === true) {
            setMasterSetupBool(masterSetupBool => masterSetupBool = true); 
            temp['companyid'] = process.env.REACT_APP_MASTER_PAYOUT_INFO_PLACEHOLDER; 
        }
        else {
            setMasterSetupBool(masterSetupBool => masterSetupBool = false); 
            if (temp['companyid'] == process.env.REACT_APP_MASTER_PAYOUT_INFO_PLACEHOLDER) {
                temp['companyid'] = null;  
            }          
        }
        console.log('TEMP: ', temp); 
        setValues(values => values = temp); 
    }

    // event handler for submit click 
    const onSubmitClick = () =>{
        return new Promise((resolve, reject) => {
            let requestValues = [{...values}];
            // add dynamic args is payoutmethod got chosen
            let dynamicArgs = {}; 
            if (!isNullOrUndefined(values['payoutmethodid'])) {
                dynamicArgs = buildAchDynamicArgs(values['payoutmethodid']); 
            }
            // validate array 
            let checkError = validateInputArray(
                requestValues, 
                payoutInfoConfig,
                dynamicValidation,
                {
                    ...payoutInfoLists, 
                    companyid: {
                        override: masterSetupBool, 
                        list: [...payoutInfoLists['companyid'], process.env.REACT_APP_MASTER_PAYOUT_INFO_PLACEHOLDER]
                    }
                }, 
                snackbarAlert,  
                error, 
                setError, 
                (row, config, args) => {
                    // run transformation on row 
                    let temp = dynamicTransformation(row, config, args); 
                    if (temp['mastersetupbool'] === true) {
                        // if mastersetup add master company placeholder
                        temp['companyid'] = process.env.REACT_APP_MASTER_PAYOUT_INFO_PLACEHOLDER; 
                    }
                    // remove index
                    delete temp['mastersetupbool']; 
                    // return transformed row 
                    return temp; 
                }, 
                dynamicArgs
            ); 
            // don't run request if error
            if (checkError) {
                reject(); 
                return; 
            }
            // add mastercompanyid to request body 
            requestValues[0]['mastercompanyid'] = masterCompanyData['mastercompanyid']; 
            // make POST request
            let response; 
            POST('/client/payoutInfo', {
                ...requestValues[0]
            }).then(res => { 
                console.log(res);
                response = res; 
                // hide modal 
                setAddPayoutInfoModal(addPayoutInfoModal => addPayoutInfoModal = false);
                // trigger success alert
                snackbarAlert(true, 'Successfully uploaded data.', 'success');
                // reset state variables
                setValues(values => values = {});
                // refresh company details page using function from parent
                return getCompanyDetailsData(company);
            }).then(res => {
                console.log(res);
                // resolve on success
                resolve(response); 
            }).catch(err => {
                console.log(err);
                // show alert on error
                snackbarAlert(true, 'Error uploading data.', 'error');
                // reject on error
                reject(err); 
            });
        }); 
    }

    // useEffect to run on config change 
    useEffect(() => {
        if (payoutInfoConfig){
            setConfig(config => config = payoutInfoConfig); 
            // set default value 
            let temp = {}; 
            for (let i = 0; i < payoutInfoConfig.length; i++ ) {
                if (payoutInfoConfig[i]['columnid'] == 'active') {
                    temp['active'] = payoutInfoLists['active'][0]; 
                }   
            }
            setValues(values => values = temp); 
        }
    }, [payoutInfoConfig]); 

    // useEffect for value change
    useEffect(() => {
        onInputChange(); 
    }, [values]); 

    return(
        <> 
            <CCOffcanvas
                title='Add Payout Info'
                show={addPayoutInfoModal}
                onCanvasClose={()=>setAddPayoutInfoModal(addPayoutInfoModal => addPayoutInfoModal = false)}
                bodyCssClassName="offcanvas-body bg-white p-3 pt-2"
                offCanvasClassName="offcanvas-parent-card-30"
                >
                    <div className="d-flex flex-column h-100">
                        <div className="d-flex flex-column gap-3 flex-grow-1 overflow-scroll">
                            {config.map((el) => 
                                el['add'] == true &&
                                isAchFieldVisible(el['columnid'], values['payoutmethodid'], showAchInfo) && // logic for showing ach info 
                                (el['columnid'] != 'companyid' || !masterSetupBool) ? // logic for showing companyid
                                <>
                                    <div>
                                        <DynamicPageInput 
                                            data={values} 
                                            setData={setValues} 
                                            config={el} 
                                            args={payoutInfoLists} 
                                            width={'100%'} 
                                            showError={error[0][el['columnid']]}
                                            topAlignTypography={true}
                                        />
                                    </div>
                                </>
                                : <></>
                            )}  
                        </div>
                        {/* button to submit sub company */}
                        <div
                               className="d-flex justify-content-end p-3 w-100 offcanvas-footer z-2" style={{height: '65px'}}
                            >
                            <ButtonComponent tag={"Cancel"} 
                                border={'#fcd800 1px solid'} background={'#fff'} color={'#001317'} 
                                onButtonClick={()=>setAddPayoutInfoModal(addPayoutInfoModal => addPayoutInfoModal = false)}
                            />
                            <ApiRequestButton onButtonClick={onSubmitClick} />
                        </div>
                    </div>
            </CCOffcanvas>
        </>
    );
}

export default AddPayoutInfoModal;